// extracted by mini-css-extract-plugin
export default {"action":"shortlist_for_profile_button___action___b5a2ad8c","tip":"shortlist_for_profile_button___tip___d5deba7f"};